import type {
  ObjectiveSelection,
  OnboardingExperience,
} from './onboardingSelections';

export type OnboardingCourseOfferDecision = 'accepted' | 'dismissed';

type BuildOnboardingCompletedPropertiesInput = {
  selection: ObjectiveSelection;
  experience: OnboardingExperience | null;
  courseOfferDecision: OnboardingCourseOfferDecision | null;
};

export function buildOnboardingCompletedProperties({
  selection,
  experience,
  courseOfferDecision,
}: BuildOnboardingCompletedPropertiesInput) {
  return {
    objective: selection.onboardingObjective,
    jobTitle: selection.jobTitle,
    ...(experience !== null ? { experience } : {}),
    ...(courseOfferDecision !== null ? { courseOfferDecision } : {}),
  };
}
